export const SUPPORTED_LOCALES = ['en', 'es', 'pt'] as const;

export type Locale = (typeof SUPPORTED_LOCALES)[number];

export const DEFAULT_LOCALE: Locale = 'en';

export const I18N_NAMESPACES = [
  'common',
  'cashier',
  'methods',
  'proof',
  'outcome',
  'errors',
] as const;

export type I18nNamespace = (typeof I18N_NAMESPACES)[number];

/**
 * Endonyms — each language named in itself. A player looking for their own language scans for
 * "Português", not for "Portuguese", and will not find the latter if they do not read English.
 */
export const LOCALE_LABELS: Readonly<Record<Locale, string>> = Object.freeze({
  en: 'English',
  es: 'Español',
  pt: 'Português',
});

/**
 * Text direction per locale. All three are `ltr` today; the field exists so that adding Urdu is a
 * data change plus a QA pass rather than an audit of every component (ADR-031, OD-C5).
 */
export const LOCALE_DIRECTIONS: Readonly<Record<Locale, 'ltr' | 'rtl'>> = Object.freeze({
  en: 'ltr',
  es: 'ltr',
  pt: 'ltr',
});
